import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useFetchFile from "../../hooks/useFetchFile";
import { PROFILE_IMAGE_URL } from "../../Consts/filePathConst";
import formatAvatarLetter from "../../utils/FormatAvatarLetter/formatAvatarLetters";

const Avatar = (props) => {
  const fetchFile = useFetchFile();
  const defaultAvatar = "/images/avatar.jpg";

  const [image, setImage] = useState(defaultAvatar);
  const [showInitials, setShowInitials] = useState(false);
  const [loading, setLoading] = useState(true);

  const name = `${props.firstName || ""} ${props.lastName || ""}`.trim();
  const initials = formatAvatarLetter(name);

  const isInvalidImage =
    !props.image ||
    props.image === "'" ||
    props.image === "null" ||
    props.image === "undefined";

  useEffect(() => {
    if (isInvalidImage) {
      setShowInitials(!!name);
      setLoading(false);
      return;
    }

    const loadImage = async () => {
      try {
        const imgSrc = await fetchFile(
          `${PROFILE_IMAGE_URL}/${props.image}`
        );
        if (imgSrc) setImage(imgSrc);
        else setShowInitials(true);
      } catch {
        setShowInitials(true);
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [props.image, name]);

  const ring = `w-${props.width || 10} h-${props.height || 10} rounded-full overflow-hidden`;

  return (
    <div className={`avatar-div relative ${ring} ${props.classes || ""}`}>
      <Link to={props.link || "#"} className="inline-block w-full h-full">

        {loading ? (
          <div className={`${ring} bg-gray-200 animate-pulse`} />

        ) : showInitials ? (
          <figure className={`${ring} bg-gray-200 flex items-center justify-center`}>
            <span
              className={`
                uppercase font-semibold text-gray-700
                ${props.initialsClassName || "text-sm"}
              `}
            >
              {initials}
            </span>
          </figure>

        ) : (
          <figure className={ring}>
            <img
              src={image}
              className="w-full h-full object-cover"
              alt="avatar"
              onError={() => setShowInitials(true)}
            />
          </figure>
        )}

      </Link>
    </div>
  );
};

export default Avatar;
